// extracted by mini-css-extract-plugin
export default {"container":"ImportantNumber_container__4ifgA","number":"ImportantNumber_number__iKr7t","text":"ImportantNumber_text__mMNLh"};